module.exports = __webpack_public_path__ + "static/media/pic4.8c2a69b3.jpg";